import { ConfigurationAtom } from "_states";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";

const Footer = () => {
  const configurations = useRecoilValue(ConfigurationAtom);

  return (
    <footer>
      <div className="bg-white py-24 px-4 space-y-16">
        <div className="max-w-7xl grid md:grid-cols-6 sm:grid-cols-2 grid-cols-1 gap-y-8 mx-auto">
          <div className="sm:col-span-2">
            <h3 className="text-2xl font-bold inline border-b border-primary pb-2">
              Get in touch
            </h3>

            <p className="font-bold border-s-2 border-primary px-4 mt-8">
              Call us 24/7
              <br />
              <span className="text-xl text-primary">
                {configurations.contact_number}
              </span>
            </p>
            <p className="font-bold border-s-2 border-primary px-4 mt-8">
              Mail us
              <br />
              <span className="text-xl text-primary">
                {configurations.contact_email}
              </span>
            </p>
          </div>

          <div>
            <div className="font-semibold underline underline-offset-8 decoration-primary mb-6">
              Company
            </div>
            <ul className="space-y-2">
              <li className="text-sm">
                <Link to="/terms-conditions">Terms &amp; Conditions</Link>
              </li>
              <li className="text-sm">
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li className="text-sm">
                <Link to="/contact">Offers</Link>
              </li>
              <li className="text-sm">
                <Link to="/contact">Contact Us</Link>
              </li>
              <li className="text-sm">
                <Link to="/">Pay Online</Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-semibold underline underline-offset-8 decoration-primary mb-6">
              Popular Destinations
            </div>
            <ul className="space-y-2">
              {configurations.featured_destinations
                .slice(0, 7)
                .map((destination, key) => (
                  <li key={key} className="text-sm">
                    <Link to={`/tours/${destination.slug}`}>
                      {destination.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <div className="font-semibold underline underline-offset-8 decoration-primary mb-6">
              Packages
            </div>
            <ul className="space-y-2">
              <li className="text-sm">
                <Link to="/destinations"> Domestic Packages</Link>
              </li>
              <li className="text-sm">
                <Link to="/destinations"> International Packages</Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-semibold underline underline-offset-8 decoration-primary mb-6">
              Let’s stay connected
            </div>
            <ul className="flex space-x-3">
              {configurations.facebook_url && (
                <li>
                  <a
                    target="_blank"
                    title="Facebook"
                    href={configurations.facebook_url}
                  >
                    <img
                      src="/facebook.svg"
                      alt="Facebook"
                      className="h-6 w-auto"
                      height={24}
                      width="auto"
                    />
                  </a>
                </li>
              )}
              {configurations.twitter_url && (
                <li>
                  <a
                    target="_blank"
                    title="Twitter"
                    href={configurations.twitter_url}
                  >
                    <img
                      src="/twitter.svg"
                      alt="Twitter"
                      className="h-6 w-auto"
                      height={24}
                      width="auto"
                    />
                  </a>
                </li>
              )}
              {configurations.instagram_url && (
                <li>
                  <a
                    target="_blank"
                    title="Instagram"
                    href={configurations.instagram_url}
                  >
                    <img
                      src="/instagram.svg"
                      alt="Instagram"
                      className="h-6 w-auto"
                      height={24}
                      width="auto"
                    />
                  </a>
                </li>
              )}
              {configurations.youtube_url && (
                <li>
                  <a
                    target="_blank"
                    title="YouTube"
                    href={configurations.youtube_url}
                  >
                    <img
                      src="/youtube.svg"
                      alt="Youtube"
                      className="h-6 w-auto"
                      height={24}
                      width="auto"
                    />
                  </a>
                </li>
              )}
              {configurations.linkedin_url && (
                <li>
                  <a
                    target="_blank"
                    title="LinkedIn"
                    href={configurations.linkedin_url}
                  >
                    <img
                      src="/linkedin.svg"
                      alt="LinkedIn"
                      className="h-6 w-auto"
                      height={24}
                      width="auto"
                    />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-slate-100 text-center text-xs py-6">
        &copy; {new Date().getFullYear()}{" "}
        <strong>{configurations.site_name}</strong>. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
